export default __webpack_public_path__ + "static/media/verseinvaders_demo_image.b5cf4dca.png";